import { Component, h } from "preact";
import CONST from "./const";


export class Like extends Component<{}, {count: string, liked: boolean, loading: boolean}> {

    csrf_token: string | undefined;
    url: string;

    constructor(props: {}) {
        super(props);
        this.state = {
            count: "---",
            liked: false,
            loading: true
        }
        let url = new URL(CONST.origin);
        url.pathname = "/like";
        this.url = url.toString();
    }

    componentDidMount() {
        console.log(CONST.origin);
        this.handle(fetch(this.url, {
            credentials: "include"
        }));
    }

    private handle(promise: Promise<Response>) {
        promise.then(r => {
            if(r.status != 200) {
                throw new Error("http error");
            }
            return r.json();
        })
        .then(data => {
            this.csrf_token = data.csrf;
            this.setState({
                loading: false,
                count: data.likes.toString(),
                liked: data.is_like
            });
        })
        .catch(reason => {
            console.log("Like Status Loading Failed", reason);
            this.setState({loading: false});
        });
    }

    onClick() {
        if(this.state.loading || this.csrf_token === undefined) {
            return;
        }
        this.setState({loading: true});
        let method = this.state.liked ? "DELETE" : "POST";
        // Build formData object.
        let formData = new FormData();
        formData.append('_csrf', this.csrf_token);
        this.handle(fetch(this.url, {
            method: method,
            credentials: "include",
            body: formData
        }));
    }
    
    render() {
        console.log(this.state);
        // this must be added at the page which embedded this.
        // <a href="https://icons8.com/icon/114150/facebook-like">Facebook Like icon by Icons8</a>
        return <div class={"like" + (this.state.loading ? " loading-like" : "")} onClick={() => this.onClick()}>
            <span class={"icon" + (this.state.liked ? " liked" : "")}></span>
            <span class="count">{this.state.count}</span>
        </div>
    }
}